<template>
  <div :class="$style.group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup'
};
</script>

<style lang="less" module src="./button.module.less" />

<i18n lang="json">{}</i18n>
